import { Button } from "@/components/ui/button";
import { CustomDropdown, CustomDropdownItem } from "@/components/ui/dropdown";
import { RadioButton } from "@/components/ui/form/radio-button";
import { Square3Stack3DIcon } from "@heroicons/react/20/solid";
import { Visualisation } from "@/api/renderer/types/renderer.type";

/* Prop Types */
interface AssetRenderMenuProps {
  visualisation: Visualisation;
  handleVisualisationChange: (visualisation: Visualisation) => void;
  children?: React.ReactNode;
}

/*
 * AssetRenderMenu component
 * Renders the asset render menu with visualisation options
 * It covers most of the dropdown options used across the kpi types and allows us to
 * add more options with children prop for more flexibility
 */
export const AssetRenderDropdown = ({ visualisation, handleVisualisationChange, children }: AssetRenderMenuProps) => {
  /* Render */
  return (
    <div className="flex flex-row gap-2 absolute right-4 top-4 z-10">
      <CustomDropdown
        className="p-0"
        dropdownClassname="drop-shadow-xs"
        listClassname="gap-1"
        triggerBtnClassname="p-0"
        align="end"
        triggerBtn={
          <Button>
            <Square3Stack3DIcon className="size-3.5 inline-block" />
          </Button>
        }
      >
        <p className="px-2 text-sm">Visual</p>
        <CustomDropdownItem className="p-0 flex" onClick={() => handleVisualisationChange("none")}>
          <div className="form-control grow px-4 py-2">
            <RadioButton checked={visualisation === "none"} size={"sm"} label="Original" readOnly />
          </div>
        </CustomDropdownItem>
        <CustomDropdownItem className="p-0 flex" onClick={() => handleVisualisationChange("heat")}>
          <div className="form-control grow px-4 py-2">
            <RadioButton checked={visualisation === "heat"} size={"sm"} label="Heatmap" readOnly />
          </div>
        </CustomDropdownItem>
        <CustomDropdownItem className="p-0 flex" onClick={() => handleVisualisationChange("opacity")}>
          <div className="form-control grow px-4 py-2">
            <RadioButton checked={visualisation === "opacity"} size={"sm"} label="Opacity" readOnly />
          </div>
        </CustomDropdownItem>
        {children && children}
      </CustomDropdown>
    </div>
  );
};
